import {
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Avatar,
  Box,
  Chip,
  Divider,
} from '@mui/material';
import { useAuthStore } from '../stores/authStore';
import { Person, Email, Badge } from '@mui/icons-material';

const Profile: React.FC = () => {
  const { user } = useAuthStore();

  if (!user) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Typography variant="h6">User not found</Typography>
      </Container>
    );
  }

  const getRoleColor = (role: string) => {
    switch (role) {
      case 'admin':
        return 'error';
      case 'educator':
        return 'primary';
      case 'learner':
      default:
        return 'default';
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        User Profile
      </Typography>

      <Card>
        <CardContent sx={{ p: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <Avatar
                  sx={{ width: 100, height: 100, mb: 2 }}
                  alt={user.full_name || user.username}
                >
                  <Person sx={{ fontSize: 50 }} />
                </Avatar>
                <Chip
                  label={user.role.toUpperCase()}
                  color={getRoleColor(user.role)}
                  variant="outlined"
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={8}>
              <Typography variant="h5" component="h2" gutterBottom>
                {user.full_name || user.username}
              </Typography>

              <Divider sx={{ my: 2 }} />

              <Box sx={{ mb: 2 }}>
                <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
                  <Person sx={{ mr: 1, color: 'text.secondary' }} />
                  <Typography variant="body1">
                    <strong>Username:</strong> {user.username}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
                  <Email sx={{ mr: 1, color: 'text.secondary' }} />
                  <Typography variant="body1">
                    <strong>Email:</strong> {user.email}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
                  <Badge sx={{ mr: 1, color: 'text.secondary' }} />
                  <Typography variant="body1">
                    <strong>Role:</strong> {user.role}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center">
                  <Typography variant="body1">
                    <strong>User ID:</strong> {user.id}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Account Information
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This profile information is managed through Keycloak authentication.
          Contact your administrator for any changes to your account details.
        </Typography>
      </Box>
    </Container>
  );
};

export default Profile;